import intersection from 'lodash/intersection';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { analyticsTrackEvent } from '../../../../core/analytics';
import { BOTTOM_NAVBAR_CHAT_ICON } from '../../../../core/analytics/events';
import history from '../../../../core/history';
import { getFirstProfileIdFromAccountSummary } from '../../../../core/util/account';
import { isEmptyArray } from '../../../../core/util/array';
import { Actions, Events } from '../../../Account/util/analytics';
import AccountViews from '../../../AccountGetsMarried/constants/AccountViews';
import usePlusChat from '../../../Membership/utils';

const NAV_MAP = [
  AccountViews.GetCare,
  AccountViews.Manage,
  AccountViews.Chat,
  AccountViews.Insurance,
  AccountViews.Profile,
];

export default () => {
  const bookingProfileId = useSelector(
    (state: any) =>
      (state.newBooking &&
        state.newBooking.booking &&
        state.newBooking.booking.userProfile &&
        state.newBooking.booking.userProfile.user_profile_id) ||
      (state.newBooking.profile && state.newBooking.profile.userProfileId)
  );
  const defaultProfileId = useSelector((state: any) =>
    getFirstProfileIdFromAccountSummary(state.account.summary)
  );

  const onChatClick = usePlusChat(BOTTOM_NAVBAR_CHAT_ICON);

  return useCallback(
    (event, newValue) => {
      const parts = window.location.pathname.split('/').filter((p, idx) => idx === 0 || p);
      let finalUrl;
      const newNav = NAV_MAP[newValue];

      if (newNav === AccountViews.Chat) {
        onChatClick();
      } else if (!isEmptyArray(intersection(parts, NAV_MAP))) {
        // @ts-expect-error ts-migrate(2363) FIXME: The right-hand side of an arithmetic operation mus... Remove this comment to see the full error message
        parts[parts.length - NAV_MAP.includes(parts[parts.length - 1])] = newNav;
        finalUrl = parts.join('/');
      } else {
        const userProfileId = bookingProfileId || defaultProfileId;
        finalUrl = `/account/home/${userProfileId}/${newNav}`;
      }

      analyticsTrackEvent(Events.ACCOUNT_NAVIGATION, {
        action: Actions.TOUCH_PRIMARY_TAB,
        label: newNav,
        fromUrl: window.location.pathname,
        toUrl: finalUrl,
      });

      if (newNav !== AccountViews.Chat) {
        history.push(finalUrl);
      }
    },
    [bookingProfileId, defaultProfileId, onChatClick]
  );
};
